import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BreedServices from '../components/BreedServices';
import BreadCumbbird from '../components/catlists/BreadCrumbOiseaux';
import Faq from '../components/Faq';
import ShopAreaBird from '../components/ourshop/ShopAreaBird';


function BirdList() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);


    return (

        <main>
            <Helmet>
                <title>Oiseaux - Animalia</title>
                <meta name="description" content="Découvrez notre sélection de nos produits pour oiseaux chez Animalia." />
            </Helmet>

            <BreadCumbbird />
            {/* <DogsList/> */}
            <ShopAreaBird />
            {/* <AdoptionShop/> */}
            <Faq afterElment="faq-area-two" />
            <BreedServices />
            {/* <NewsLetter /> */}
        </main>
    )
}

export default BirdList;
